import styled from "styled-components";

const CategoriesContainer = styled.div``;

export { CategoriesContainer };
